/*eslint-disable */

export default {
    "Apto Tipo 1 Internos": "https://umbra3d.studio/recorridos/centrosur/ferratore/",
    "Apto Tipo 1 Externos": "https://umbra3d.studio/recorridos/centrosur/ferratore/",
    "Apto Tipo 2 Internos": "https://umbra3d.studio/recorridos/centrosur/ferratore/",
    "Apto Tipo 2 Externos": "https://umbra3d.studio/recorridos/centrosur/ferratore/",
    "Apto Tipo 3 Externos": "https://umbra3d.studio/recorridos/centrosur/ferratore/",
}